<template>
  <div>
    <h1>Not Authorized</h1>
    <p>You are not authorized to view this page.</p>
    <I18nRouteLink :to="props.redirectTo ?? '/'">{{ $t("shared.ui.buttons.back") }}</I18nRouteLink>
    <DxButton @click="logout">{{$t("shared.ui.buttons.logout")}}</DxButton>
  </div>
</template>

<script setup lang="ts">
import I18nRouteLink from '../components/i18n/I18NRouteLink.vue';
import { useAuthentication } from '../services/auth';
import { DxButton } from 'devextreme-vue';

const props = defineProps<{
  redirectTo?: string;
}>();

const auth = useAuthentication();

function logout() {
    auth.logout(import.meta.env.VITE_BASE_URL);
}

</script>